import Vue from 'vue';
import {AxiosInstance, getAuthHeaders, validateUser} from './api';

export const getRoleList = async () => {
  try {
    let response = await AxiosInstance.get(`/role/list`);
    if (response.status === 200) {
      return response?.data;
    }
  } catch (error) {
    return error.response?.data;
  }
};

export const getRolePageGroups = async () => {
  try {
    let headers = getAuthHeaders();
    let response = await AxiosInstance.get(`/role/pagegroups`, {headers});
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

export const getRoleCompanies = async () => {
  try {
    let headers = getAuthHeaders();

    let response = await AxiosInstance.get(`/company/list`, {headers});
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

export const getRoleShips = async () => {
  try {
    let headers = getAuthHeaders();

    let response = await AxiosInstance.get(`/ship/list`, {headers});
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

export const getRoleById = async (id) => {
  try {
    let response = await AxiosInstance.get(`/role/${id}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response.data;
  }
};

export const createRole = async (role) => {
  try {
    let headers = getAuthHeaders();
    let response = await AxiosInstance.post(`/role/create`, {...role}, {headers});
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

export const updateRole = async (role, id) => {
  try {
    let headers = getAuthHeaders();
    let response = await AxiosInstance.put(`/role/update/${id}`, {...role}, {headers});
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

export const updateRoleStatus = async (role, id) => {
  try {
    let headers = getAuthHeaders();
    let response = await AxiosInstance.put(`/role/updatestatus/${id}`, {...role}, {headers});
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

export const deleteRole = async (id) => {
  try {
    let headers = getAuthHeaders();
    let response = await AxiosInstance.delete(`/role/delete/${id}`, {
      headers,
    });
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

export const assignRole = async (role) => {
  try {
    let headers = getAuthHeaders();
    let response = await AxiosInstance.post(`/role/assignusers`, {...role}, {headers});
    if (validateUser(response)) {
      if (response.status === 200) {
        return response.data;
      }
    }
  } catch (error) {
    return error.response.data;
  }
};

//Assign role user list
export const getAssignedRoleList = async () => {
  try {
    let response = await AxiosInstance.get(`/role/users`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response.data;
  }
};

export const getAssignedRoleByUserId = async (id) => {
  try {
    let response = await AxiosInstance.get(`/role/userauthorities/${id}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response.data;
  }
};
